import { apiClient } from "./apiClient";

export interface TradeHistoryItem {
  id: string;
  symbol: string;
  direction: string | null;
  outcome: string;
  pnl_pct: number | null;
  pnl_usdt: number | null;
  entry_price: number | null;
  exit_price: number | null;
  quantity: number | null;
  stop_loss_price: number | null;
  take_profit_prices: number[] | null;
  sl_hit: boolean | null;
  tp1_hit: boolean | null;
  tp2_hit: boolean | null;
  tp3_hit: boolean | null;
  trade_open_time: string | null;
  trade_close_time: string | null;
  created_at: string;
  confidence: number | null;
  final_score: number | null;
  macro_bias: string | null;
  source: string | null;
  risk_reward_ratio: number | null;
  has_ta: boolean;
  technical_analysis: Record<string, unknown> | null;
  filter_snapshot: Record<string, unknown> | null;
  filter_evaluations: Array<{
    category: string;
    name: string;
    passed: boolean;
    actual_value: number | null;
    threshold_low: number | null;
    threshold_high: number | null;
    detail: string | null;
    overall_score: number | null;
    evaluated_at: string | null;
  }> | null;
  metadata_json: Record<string, unknown> | null;
  analysis: string | null;
  success_factors: string[] | null;
  failure_reasons: string[] | null;
  recommendation_id: string | null;
  xgboost_score: number | null;
  xgboost_passed: boolean | null;
  xgboost_threshold: number | null;
  xgboost_model_version: string | null;
  xgboost_reason: string | null;
  xgboost_top_features: Array<{ name: string; value: number }> | null;
}

export interface TradeHistoryFilters {
  outcomes: string[];
  symbols: string[];
  macro_biases: string[];
  directions: string[];
  sources: string[];
}

export interface TradeHistoryResponse {
  items: TradeHistoryItem[];
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
  filters: TradeHistoryFilters;
}

export interface TradeHistoryParams {
  time_range?: string;
  outcome?: string;
  symbol?: string;
  direction?: string;
  has_ta?: string;
  macro_bias?: string;
  source?: string;
  sl_hit?: string;
  score_min?: number;
  score_max?: number;
  search?: string;
  page?: number;
  page_size?: number;
  sort_by?: string;
  sort_order?: string;
}

export async function getTradeHistory(
  params: TradeHistoryParams = {},
): Promise<TradeHistoryResponse> {
  const query = new URLSearchParams();
  const defaults: TradeHistoryParams = {
    time_range: "90d",
    page: 1,
    page_size: 50,
    sort_by: "created_at",
    sort_order: "desc",
  };

  const merged = { ...defaults, ...params };

  for (const [key, value] of Object.entries(merged)) {
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, String(value));
    }
  }

  const response = await apiClient.get<TradeHistoryResponse>(
    `/admin/reports/trade-history?${query.toString()}`,
  );
  return response.data;
}

export function outcomeLabel(outcome: string): string {
  switch (outcome) {
    case "win":
      return "WIN";
    case "loss":
      return "SL";
    case "timeout":
      return "TIMEOUT";
    case "breakeven":
      return "BREAKEVEN";
    case "unknown":
      return "UNKNOWN";
    default:
      return outcome.toUpperCase();
  }
}

export function outcomeColor(outcome: string): string {
  switch (outcome) {
    case "win":
      return "#16a34a";
    case "loss":
      return "#dc2626";
    case "timeout":
      return "#ca8a04";
    case "breakeven":
      return "#6b7280";
    case "unknown":
      return "#94a3b8";
    default:
      return "#6b7280";
  }
}
